<template>
  <div>
    <div v-show="mode==='0'">
      <h1 class="mb-3">Add/Invite Members</h1>
      <hr />
      <div id="addInviteMemberPanel">
      
        <div id="options" class="row">
          <div class="col-lg-6">
            <h4 class="text-dark mb-4">Input Type <button class="btn-transparent" @click="addInviteHelp(0)"><font-awesome-icon icon="question-circle"></font-awesome-icon></button></h4>
            <div class="field rounded shadow bg-white p-4 mb-3 mb-lg-3">
              <input type="radio" name="aIinputType" id="aIinputEmail" value="email" v-model="useInvite"> Email Address (Invite)<br>
              <input type="radio" name="aIinputType" id="aIinputUser" value="user" v-model="useInvite"> Username/Password (Add)
            </div>
          </div>
          <div class="col-lg-6">
            <h4 class="text-dark mb-4">Input Method <button class="btn-transparent" @click="addInviteHelp(1)"><font-awesome-icon icon="question-circle"></font-awesome-icon></button></h4>
            <div class="field rounded shadow bg-white p-4 mb-3 mb-lg-5">
              <input type="radio" name="aIinputMethod" id="aIinputIndiv" value="individual" v-model="useIndividual"> Individual<br>
              <input type="radio" name="aIinputMethod" id="aIinputBulk" value="bulk" v-model="useIndividual"> Bulk
            </div>
          </div>
        </div>
        <hr>
       
 
        <div id="individualFlow" class="row" v-show="useIndividual==='individual'">
          <div id="inviteBox" class="col-md-5 mb-5" v-show="useInvite==='email'">
            <div class="row">
              <div class="field col-md-12 mb-4">
                <label>Email Address*</label><input type="text" v-model="addEmailAddress" class="mb-0 fullWidth" autocomplete="off">
              </div>
              <div class="field col-md-12 mb-4">
                <label>
                  Password (Min 11 Characters – Optional)<br>
                  <span style="font-weight:300!important;font-size:1em;color:#999993!important;">
                    By specifying a password you will bypass verification<br>
                    and no email will be sent to the user about their account
                  </span>
                </label>
                <input type="password" v-model="addPasswordEmail" class="mb-0 fullWidth" autocomplete="off">
              </div>
              <div class="field col-md-12 mb-4">
                <label>First Name (Optional)</label>
                <input type="text" v-model="addFirstNameEmail" class="mb-0 fullWidth" autocomplete="off">
              </div>
              <div class="field col-md-12 mb-4">
                <label>Last Name (Optional)</label>
                <input type="text" v-model="addLastNameEmail" class="mb-0 fullWidth" autocomplete="off">
              </div>
            </div>
          </div>
          <div id="addBox" class="col-md-5 mb-5" v-show="useInvite==='user'">
            <div class="row">
              <div class="field col-md-12 mb-4">
                <label>Username*</label>
                <input type="text" v-model="addUsername" class="mb-0 fullWidth">
              </div>
              <div class="field col-md-12 mb-4">
                <label>Password (Min 11 Characters)*</label>
                <input type="password" v-model="addPassword" class="mb-0 fullWidth">
              </div>
              <div class="field col-md-12 mb-4">
                <label>First Name (Optional)</label>
                <input type="text" v-model="addFirstNameUser" class="mb-0 fullWidth">
              </div>
              <div class="field col-md-12 mb-4">
                <label>Last Name (Optional)</label>
                <input type="text" v-model="addLastNameUser" class="mb-0 fullWidth">
              </div>
            </div>
          </div>
          <div id="addInviteShowAdded" class="col-md-7 mb-5 rounded bg-white shadow p2">
            <h4>List of Members To Add</h4>
            <p>Please add members by filling out the fields on the left and clicking 'Move To List'</p>
            <table id='willAddTable' v-show="usersToAdd.length>0">
              <tr><td><b>Email Address/Username</b></td><td><b>First Name</b></td><td><b>Last Name</b></td><td><b>Edit/Delete</b></td></tr>
              <tr v-for="user in usersToAdd">
                <td v-show="user.EmailAddress===null">{{user.Username}}</td>
                <td v-show="user.EmailAddress!==null">{{user.EmailAddress}}</td>
                <td>{{user.FirstName}}</td>
                <td>{{user.LastName}}</td>
                <td>
                  <button class="btn-transparent" @click='editAddInvite(user)'><font-awesome-icon icon="edit" aria-label="Edit invited user"></font-awesome-icon></button>&nbsp;&nbsp;
                  <button class="btn-transparent" @click='removeAddInvite(user.Num)'><font-awesome-icon icon="times" aria-label="Remove invited user"></font-awesome-icon></button>
                </td>
              </tr>
            </table>
          </div>
          <div class="button-wrapper col-md-12 mt-3 mt-lg-2">
            <button class="btn btn-secondary btn-medium" @click="addInviteChoose()">Move To List</button>
          </div>
        </div>
        <hr>
      </div>
      <div class="row mt-5 mb-5" id="bulkBox" v-show="useIndividual==='bulk'">
        <div class="field col-12">
          <p v-show="useInvite==='email'">
            Paste or enter entries in the following format (include commas): Email Address, Password, FirstName, LastName<br />
            <b>All fields are required, even if blank</b>. If you have multiple entries, separate them with a semi-colon (;)<br /><br />
            <i>Examples:</i><br />
            1. Email Address, No Password, Two Members: student1@student.com,,FirstName,LastName;student2@student.com,,FirstName2,LastName2<br />
            2. Email Address, Password: student1@student.com,examplepassword1234,FirstName,LastName<br />
            3. Email Address Only, Two Members: student1@student.com,,,;student2@student.com,,,
          </p>
          <p v-show="useInvite==='user'">
            Paste or enter entries in the following format (include commas): Username, Password, FirstName, LastName<br />
            <b>All fields are required, even if blank</b>. If you have multiple entries, separate them with a semi-colon (;)<br /><br />
            <i>Examples:</i><br />
            1. Username, Two Members: username1,examplepassword1234,FirstName,LastName;username2,examplepassword3456,FirstName2,LastName2 <br />
            2. Username Only, Two Members: username1,examplepassword1234,,;username2,examplepassword1234,,
          </p>
          <textarea style="width:100%;height:200px;" v-model="bulkAdd" class="mt-2 mb-0"></textarea>
          <hr>
        </div>
      </div>

      <h4 class="text-dark mb-4">Assign Groups/Products/Bundles/Curricula <button class="btn-transparent" @click="addInviteHelp(2)"><font-awesome-icon icon="question-circle"></font-awesome-icon></button></h4>
      <div id="addInviteChoicePanel" class="row d-flex flex-wrap">
        <div class="bubbleBox col-12 col-md-6 col-lg-3 mr-auto">
          <div class="field bg-white shadow rounded p-4">
            <label>Groups To Assign</label>
            <div class="mt-2" v-show="assignGroups.length===0">None Selected</div>
            <div class="row mt-1" v-show="assignGroups.length>0" v-for="group in assignGroups">
              <div class="col-9" v-html="group.name">
              </div>
              <div class="col-3 text-right">
                <button class="btn-transparent" @click="removeGroup(group.value)"><font-awesome-icon icon="times"></font-awesome-icon></button>
              </div>
            </div>
            <button class="btn btn-secondary btn-short mt-2" @click="openAssignGroups()">Assign Groups</button>
          </div>
        </div>
        <div class="bubbleBox col-12 col-md-6 col-lg-3 mr-auto mt-5 mt-md-0">
          <div class="field bg-white shadow rounded p-4">
            <label>Products to Assign</label>
            <div class="mt-2" v-show="assignProducts.length===0">None Selected</div>
            <div class="row mt-1" v-show="assignProducts.length>0" v-for="product in assignProducts">
              <div class="col-9" v-html="product.ProductName">
              </div>
              <div class="col-3 text-right">
                <button class="btn-transparent" @click="removeProduct(product.LicensePoolProductID)"><font-awesome-icon icon="times"></font-awesome-icon></button>
              </div>
            </div>
            <button class="btn btn-secondary btn-short mt-2" @click="openAssignProducts()">Assign Products</button>
          </div>
        </div>
        <div class="bubbleBox col-12 col-md-6 col-lg-3 mr-auto mt-5 mt-md-0">
          <div class="field bg-white shadow rounded p-4">
            <label>Bundles to Assign</label>
            <div class="mt-2" v-show="assignBundles.length===0">None Selected</div>
            <div class="row mt-1" v-show="assignBundles.length>0" v-for="bundle in assignBundles">
              <div class="col-9" v-html="bundle.BundleName">
              </div>
              <div class="col-3 text-right">
                <button class="btn-transparent" @click="removeBundle(bundle.BundleID)"><font-awesome-icon icon="times"></font-awesome-icon></button>
              </div>
            </div>
            <button class="btn btn-secondary btn-short mt-2" @click="openAssignBundles()">Assign Bundles</button>
          </div>
        </div>
        <div class="bubbleBox col-12 col-md-6 col-lg-3 ml-lg-auto mr-auto mt-5 mt-lg-0">
          <div class="field bg-white shadow rounded p-4">
            <label>Training Plans to Assign</label>
            <div class="mt-2" v-show="assignTrainingPlans.length===0">None Selected</div>
            <div class="row mt-1" v-show="assignTrainingPlans.length>0" v-for="tp in assignTrainingPlans">
              <div class="col-9" v-html="tp.CurriculumName">
              </div>
              <div class="col-3 text-right">
                <button class="btn-transparent" @click="removeTP(tp.CurriculumID)"><font-awesome-icon icon="times"></font-awesome-icon></button>
              </div>
            </div>
            <button class="btn btn-secondary btn-medium mt-2" @click="openAssignTrainingPlans()">Assign Training Plans</button>
          </div>
        </div>
      </div>
      <div style="clear:both;"></div>
      <hr>
      <div id="addInviteEmailPanel" class="row">
        <div class="col-12">
          <h4 class="text-dark mb-4">Email Options <button class="btn-transparent" @click="addInviteHelp(3)"><font-awesome-icon icon="question-circle"></font-awesome-icon></button></h4>
          <div id="delayVerificationBox" class="mb-4">
            <div class="field rounded shadow bg-white p-4">
              <input type="checkbox" class="checkbox" v-model="delayEmail"> Delay Sending of Verification Email
            </div>
          </div>
          <p class="w-100 col-12" v-show="delayEmail===true">
            <label>Choose a Date To Send Email</label>
            <v-date-picker v-model="emaildate"></v-date-picker>
          </p>
        </div>
        <div class="button-wrapper mt-3 mb-3 mt-lg-5 text-right">
          <button class="btn btn-primary btn-medium" @click="doAddInvite()" v-show="notActive===true">Add/Invite New Members</button>
        </div>
      </div>

    </div>
    <div v-if="mode==='5'">
      <h2>Add/Invite Results</h2>
      <div class="row mt-2" v-for="user in userGuids" v-if="userGuids.length>0">
         <div class="col-4">
            {{user.name}}
         </div>
         <div class="col-8">
           <div class="mb-2" v-if="user.groupitems.length>0">
             <b>Groups Assigned</b>
             <div class="row" v-for="item in user.groupitems">
               <div class="col-6">
                 {{item.name}}
               </div>
               <div class="col-6">
                 {{item.result}}
               </div>
             </div>
           </div>
           <div class="mb-2" v-if="user.productitems.length>0">
             <b>Products Assigned</b>
             <div class="row" v-for="item in user.productitems">
               <div class="col-6">
                 {{item.name}}
               </div>
               <div class="col-6">
                 {{item.result}}
               </div>
             </div>
           </div>
           <div class="mb-2" v-if="user.bundleitems.length>0">
             <b>Bundles Assigned</b>
             <div class="row" v-for="item in user.bundleitems">
               <div class="col-6">
                 {{item.name}}
               </div>
               <div class="col-6">
                 {{item.result}}
               </div>
             </div>
           </div>
           <div v-if="user.tpitems.length>0">
             <b>Training Plans Assigned</b>
             <div class="row" v-for="item in user.tpitems">
               <div class="col-6">
                 {{item.name}}
               </div>
               <div class="col-6">
                 {{item.result}}
               </div>
             </div>
           </div>
         </div>
      </div>
      <div class="mt-2" v-if="userGuids.length===0">
         No members were added/invited
      </div>
    </div>
    <div v-if="mode==='1'">
      <div class="row">
        <div class="col-8">
          <h2>Assign Bundles</h2>
        </div>
        <div class="col-4 text-right">
          <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon>Go Back</a>
        </div>
      </div>
      <selectbundles ref="selectedBundleModule"></selectbundles>
    </div>
    <div v-if="mode==='2'">
      <div class="row">
        <div class="col-8">
          <h2>Assign Groups</h2>
        </div>
        <div class="col-4 text-right">
          <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon>Go Back</a>
        </div>
      </div>
      <selectusers ref="selectedUserModule" :mode="'2'" :backbutton="false" :notitle="true"></selectusers>
    </div>
    <div v-if="mode==='3'">
      <div class="row">
        <div class="col-8">
          <h2>Assign Products</h2>
        </div>
        <div class="col-4 text-right">
          <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon>Go Back</a>
        </div>
      </div>
      <selectproducts ref="selectedProductModule"></selectproducts>
    </div>
    <div v-if="mode==='4'">
      <div class="row">
        <div class="col-8">
          <h2>Assign Training Plans</h2>
        </div>
        <div class="col-4 text-right">
          <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon>Go Back</a>
        </div>
      </div>
      <selecttrainingplans ref="selectedTPModule"></selecttrainingplans>
    </div>

    <b-modal title="Add/Invite Help" ref="helpModal">
      <div v-html="helptext">
      </div>
    </b-modal>

    <b-modal title="Edit" size="lg" ref="editModal" @ok="doEditAddInvite">
      <div class="row" v-show="useInvite==='email'">
        <div class="col-4">
          <label class="text-dark">Email Address*:</label>
        </div>
        <div class="col-8">
          <input v-model="eEmail" type="text" class="fullWidth" />
        </div>
      </div>
      <div class="row" v-show="useInvite==='user'">
        <div class="col-4">
          <label class="text-dark">Username*:</label>
        </div>
        <div class="col-8">
          <input v-model="eUser" type="text" class="fullWidth" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-4">
          <label class="text-dark">Password<span v-show="useInvite==='user'">*</span>:</label>
        </div>
        <div class="col-8">
          <input v-model="ePassword" type="password" class="fullWidth" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-4">
          <label class="text-dark">First Name:</label>
        </div>
        <div class="col-8">
          <input v-model="eFirstName" type="text" class="fullWidth" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-4">
          <label class="text-dark">Last Name:</label>
        </div>
        <div class="col-8">
          <input v-model="eLastName" type="text" class="fullWidth" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
  .field label {
    color: #2A6693;
  }
  #inviteBox,#addBox {
     padding-right:5%;
  }
  #willAddTable {
     width:100%;
     margin-bottom:30px;
  }
</style>

<script>
  import selectbundles from "./SelectBundles.vue"
  import selectusers from "./SelectUsers.vue"
  import selectproducts from "./SelectProducts.vue"
  import selecttrainingplans from "./SelectTrainingPlans.vue"

  export default {
    name: "AddInvite",
    props:["poolID","groupID"],
    components: {selectbundles,selectusers,selectproducts,selecttrainingplans},
    data() {
      return {
        addEmailAddress:"",
        addPasswordEmail:"",
        addFirstNameEmail:"",
        addLastNameEmail:"",
        addPassword:"",
        addUsername:"",
        addFirstNameUser:"",
        addLastNameUser:"",
        assignBundles:[],
        assignGroups:[],
        assignProducts:[],
        assignTrainingPlans:[],
        bulkAdd:"",
        delayEmail: false,
        emaildate: null,
        eUser:null,
        ePassword:null,
        eFirstName:null,
        eLastName:null,
        eEmail:null,
        eID:null,
        helptext: null,
        mode:'0',
        notActive:true,
        useInvite: "email",
        useIndividual: "individual",
        userGuids:[],
        usersToAdd:[]
      }
    },
    methods: {
      addInviteChoose() {
        if (this.useInvite==="email") {
          if (this.addEmailAddress.indexOf("@") > -1 && this.addEmailAddress.length >= 3) {

            for (var z = 0; z < this.usersToAdd.length; z++) {
              if (this.usersToAdd[z].EmailAddress == this.addEmailAddress) {
                this.popDialog(1,"Cannot add duplicate email addresses");
                return;
              }
            }

            var ea = this.addEmailAddress.trim();
            var ep = this.addPasswordEmail.trim();

            if (ep.length>0) {
              if (ep.indexOf(",")>-1 || ep.indexOf(";")>-1) {
                this.popDialog(1, "Semicolons and commas not allowed in passwords");
                return;
              }
              if (ep.length < 11) {
                this.popDialog(1,"The password must be at least 11 characters");
                return;
              }
            }

            this.usersToAdd.push({
              Num: this.usersToAdd.length,
              Username: null,
              EmailAddress: ea.replace(",", "_").replace(";", "_"),
              Password: ep.replace(",", "_").replace(";", "_"),
              FirstName: this.addFirstNameEmail.replace(",", "_").replace(";", "_"),
              LastName: this.addLastNameEmail.replace(",", "_").replace(";", "_")
            });

            this.addEmailAddress="";
            this.addPasswordEmail="";
            this.addFirstNameEmail=="";
            this.addLastNameEmail="";

          }
          else {
            this.popDialog(1,"The email address is invalid");
          }
        }
        else {
          if (this.addUsername.length > 0) {

            for (var z = 0; z < this.usersToAdd.length; z++) {
              if (this.usersToAdd[z].Username == this.addUsername) {
                this.popDialog(1,"Cannot add duplicate usernames");
                return;
              }
            }

            var ea = this.addUsername.trim();
            var ep = this.addPassword.trim();

            if (ep.replace(",", "_").replace(";", "_").length < 11) {
              this.popDialog(1,"The password must be at least 11 characters");
              return;
            }

         

            this.usersToAdd.push({
              Num: this.usersToAdd.length,
              EmailAddress: null,
              Username: ea.replace(",", "_").replace(";", "_"),
              Password: ep.replace(",", "_").replace(";", "_"),
              FirstName: this.addFirstNameUser.replace(",", "_").replace(";", "_"),
              LastName: this.addLastNameUser.replace(",", "_").replace(";", "_")
            });

            this.addUsername="";
            this.addPassword=""; 
            this.addFirstNameUser="";
            this.addLastNameUser=""; 

      
          }
          else {
            this.popDialog(1,"Username is required")
          }
        }
      },
      addInviteHelp(num) {

        var cnt = ""; 
        if (num == 0) {
          cnt = "<p>Input type allows you to specify whether or not you want to identify your members with an email address or username.</p>";
          cnt += "<p>If you choose email address then you will have the option to have the system notify the members of their new account via email and have them choose their own account password. The system will only do this if a password is not specified for the student in the password field.</p>";
          cnt += "<p>If you choose username then you will have to specify both a username and password for each student and then inform your members of their credentials.</p>";
        }

        if (num == 1) {
          cnt = "<p>Input method allows you to specify whether or not you want to add the new members one at a time (individual) or all at once (bulk)</p>";
          cnt += "<p>If you choose individual then you will need to add the email address or username as well as the password (if specified or required) and first name or last name (optional) in each of the fields provided and then click 'Move to List'</p>";
          cnt += "<p>If you choose bulk then you will have the option to specify each email address or username on one line within the provided field, with the values being delimited by a comma or semicolon. Please note that each field is required, even if it is not being used.</p>";
        }

        if (num == 2) {
          cnt = "<p>This section allows you to assign existing groups, products, or curricula to the new members as their accounts are created.</p>";
          cnt += "<p>If you choose to assign groups then the new members will be placed into those groups. Note that group placement alone does not assign products or curricula to the student. Those options must be chosen separately.</p>";
          cnt += "<p>If you choose to assign products then the new members will receive those products. You must have enough product licenses in order to complete the assignment or you will receive an error message.</p>";
          cnt += "<p>If you choose to assign curricula then the new members will be placed into those curricula as well as be assigned whatever products are required by that curricula. If there are not enough product licenses then this assignment will fail.</p>";
        }

        if (num == 3) {
          cnt = "<p>If you are using email addresses and plan to email your members with account information then you may delay the sending of these emails until the specified date. The emails will go out at 12:05 A.M. EST/EDT on that date.</p>";
        }

        this.helptext=cnt;
        this.$refs["helpModal"].show();
      },
      breakDownBulk() {
        var nms = this.bulkAdd.split(';');

        for (var x = 0; x < nms.length; x++) {

          var nmup=[];
          var newuserobj = {
            EmailAddress:null,
            Username:null,
            Password:null,
            FirstName:null,
            LastName:null                    
          }; 

          if (nms[x].indexOf(",") > -1) {
            nmup = nms[x].split(',');
          }
     
          if (nmup.length>0)
          {

            if (this.useInvite==='email') {

              for (var z = 0; z < this.usersToAdd.length; z++)
              {
                if (this.usersToAdd[z].EmailAddress == nmup[0])
                {
                  this.popDialog(1,"Cannot add duplicate email addresses");
                  this.usersToAdd = [];
                  return;
                }
              }

              if (nmup[0].indexOf(".") === -1 || nmup[0].indexOf("@") === -1) {
                this.popDialog(1,"At least one email address is invalid");
                this.usersToAdd=[];
                return;
              }
              else {

                if (nmup[1].length>0 && nmup[1].length < 11) {
                  this.popDialog(1,"At least one password is not 11 characters or more in length. The minimum password length is 11");
                  this.usersToAdd = [];
                  return;
                }

                var ea = nmup[0].trim();            
                var ep = nmup[1].trim();
                 
                newuserobj.EmailAddress= ea; 
                newuserobj.Password= ep; 
                newuserobj.FirstName = nmup.length >= 2 ? nmup[2] : "";
                newuserobj.LastName = nmup.length >= 3 ? nmup[3] : "";
              }
            }
            else {

              if (nmup.length < 2) {
                this.popDialog(1,"At least one username/password combination is invalid");
                this.usersToAdd=[];
                return;
              }
              else {

                for (var z = 0; z < this.usersToAdd.length; z++) {
                  if (this.usersToAdd[z].Username == nmup[0]) {
                    this.popDialog(1,"Cannot add duplicate usernames");
                    this.usersToAdd = [];
                    return;
                  }
                }

                if (nmup[1].length < 11) {
                  this.popDialog(1,"At least one password is not 11 characters or more in length. The minimum password length is 11");
                  this.usersToAdd=[];                              
                  return;
                }
                else if (nmup[0].length > 20) {
                  this.popDialog(1,"At least one username is more than 20 characters in length - the maximum limit is 20");
                  this.usersToAdd=[];
                  return;
                }
                else {

                  var ea = nmup[0].trim();   
                  var ep = nmup[1].trim();
                  
                  newuserobj.Username= ea; 
                  newuserobj.Password= ep; 
                  newuserobj.FirstName = nmup.length >= 2 ? nmup[2] : "";
                  newuserobj.LastName = nmup.length >= 3 ? nmup[3] : "";
                }
              }
            }

            this.usersToAdd.push(newuserobj);
          }
        }
      },
      buildAPICommands() {
        var initialAPICommands=[];

        for (var x = 0; x < this.usersToAdd.length; x++) {
          var fieldObj = {
            "FirstName": this.usersToAdd[x].FirstName,
            "LastName": this.usersToAdd[x].LastName,
            "PoolID": this.poolID,
            "PromoCode": "",
          };

          if (this.delayEmail===true && this.emaildate!==null) {
            fieldObj.Delay = this.emaildate;
          }

          if (this.groupID !== null) {
            fieldObj.GroupID = this.groupID
          }

          if (this.usersToAdd[x].EmailAddress === null) {
            fieldObj.Username = this.usersToAdd[x].Username;
          }
          else {
            fieldObj.EmailAddress = this.usersToAdd[x].EmailAddress;
          }
      
          if (this.usersToAdd[x].Password != null && this.usersToAdd[x].Password != "") {
            fieldObj._P = this.usersToAdd[x].Password;
          }

          initialAPICommands.push({
            "Operation": "Client",
            "Function": "Invite",
            "Fields": fieldObj
          });
        }

        return initialAPICommands;
      },
      doAddInvite() {
        if (this.useIndividual==='bulk') {
          if (this.bulkAdd.length===0) {
            this.popDialog(1,"No members to add");
            return;
          }
          this.breakDownBulk();
        }
        else {
          if (this.usersToAdd.length===0) {
            this.popDialog(1,"No members to add");
            return;
          }
        }

        if (this.usersToAdd.length>0) {
          this.notActive=false;
          var cmds=this.buildAPICommands();

          this.apiCommand(cmds).then(response=> {

            var cr = JSON.parse(response.CommandResult);

            for (var q = 0; q < cr.returnObjects.length; q++) {
              if (cr.returnObjects[q].returnObject.length == 36) {
                this.userGuids.push({id: cr.returnObjects[q].returnObject, name:this.buildSimUser(this.emptyguid,cmds[q].Fields.Username,cmds[q].Fields.EmailAddress,cmds[q].Fields.FirstName,cmds[q].Fields.LastName,false,false)+" Added",  tpitems:[], bundleitems:[], productitems:[], groupitems:[]});
              }
              else {
                this.userGuids.push({id: null, name:this.buildSimUser(this.emptyguid,cmds[q].Fields.Username,cmds[q].Fields.EmailAddress,cmds[q].Fields.FirstName,cmds[q].Fields.LastName,false,false)+" "+cr.returnObjects[q].returnObject, tpitems:[], bundleitems:[], productitems:[], groupitems:[]});
              }
            }

            if (this.userGuids.length > 0) {
          
              var users=[];
              var curriculaCommands = [];
              var groupCommands = [];
              var productCommands = [];
              var bundleCommands = [];

              for (var user of this.userGuids.filter(p=>p.id!==null)) {

                
                for (var y = 0; y < this.assignGroups.length; y++) {
                  if (groupCommands.filter(p=>p.Fields.LicensePoolGroupID===this.assignGroups[y].value && p.Fields.ClientID===user.id).length===0) {
                    groupCommands.push({
                      Operation: "LicensePool",
                      Function: "AddMemberToGroup",
                      Fields: {
                        LicensePoolGroupID: this.assignGroups[y].value,
                        LicensePoolID: this.poolID,
                        ClientID: user.id
                      }
                    });
                  
                    user.groupitems.push({name:this.assignGroups[y].name,result:null})
                  }
                }

                for (var y = 0; y < this.assignProducts.length; y++) {
                  if (productCommands.filter(p=>p.Fields.ProductID===this.assignProducts[y].ProductID && p.Fields.ClientID===user.id).length===0) {
                    productCommands.push({
                      Operation: "Client",
                      Function: "AddProduct",
                      Fields: {
                        FromPoolID: this.poolID,
                        ClientID: user.id,
                        ProductID: this.assignProducts[y].ProductID,
                        LicenseType: this.assignProducts[y].LicenseType,
                        LicensePoolProductID: this.assignProducts[y].LicensePoolProductID
                      }
                    });
                    user.productitems.push({name:this.assignProducts[y].ProductName,result:null});
                  }
                }

                for (var b = 0; b < this.assignBundles.length; b++) {
                  if (bundleCommands.filter(p=>p.Fields.BundleID===this.assignBundles[b].BundleID && p.Fields.ClientID===user.id).length===0) {
                    bundleCommands.push({
                      Operation: "Client",
                      Function: "AssignBundle",
                      Fields: {
                        ClientID: user.id,
                        BundleID: this.assignBundles[b].BundleID
                      }
                    });
                    user.bundleitems.push({name:this.assignBundles[b].BundleName,result:null});
                  }
                }

                for (var y = 0; y < this.assignTrainingPlans.length; y++) {
                  if (curriculaCommands.filter(p=>p.Fields.CurriculumID===this.assignTrainingPlans[y].CurriculumID && p.Fields.ClientID===user.id).length===0) {

                    curriculaCommands.push({
                      Operation: "LicensePool",
                      Function: "AddMemberToCurricula",
                      Fields: {
                        LicensePoolID: this.poolID,
                        ClientID: user.id,
                        CurriculumID: this.assignTrainingPlans[y].CurriculumID
                      }
                    });
                    user.tpitems.push({name:this.assignTrainingPlans[y].CurriculumName,result:null});
                  }

             
                  users.push(user);
                }

              
                
              }

              this.runAssignments(users,groupCommands,bundleCommands,productCommands,curriculaCommands);
                       
            }

            this.mode='5';

          })

        }

      },
      doEditAddInvite() {
        if (this.useInvite==="email") {
          if (this.eEmail.indexOf("@") > -1 && this.eEmail.length >= 3) {

 

            var ea = this.eEmail.trim();
            var ep = this.ePassword.trim();

            if (ep.length>0) {
              if (ep.indexOf(",")>-1 || ep.indexOf(";")>-1) {
                this.popDialog(1, "Semicolons and commas not allowed in passwords");
                return;
              }
              if (ep.length < 11) {
                this.popDialog(1,"The password must be at least 11 characters");
                return;
              }
            }
          
            this.eID.EmailAddress= ea.replace(",", "_").replace(";", "_");
            this.eID.Password= ep.replace(",", "_").replace(";", "_");
            this.eID.FirstName= this.eFirstName.replace(",", "_").replace(";", "_");
            this.eID.LastName= this.eLastName.replace(",", "_").replace(";", "_");         

          }
          else {
            this.popDialog(1,"The email address is invalid");
          }
        }
        else {
          if (this.eUser.length > 0) {

            for (var z = 0; z < this.usersToAdd.length; z++) {
              if (this.usersToAdd[z].Username == this.eUser) {
                this.popDialog(1,"Cannot add duplicate usernames");
                return;
              }
            }

            var ea = this.eUser.trim();
            var ep = this.ePass.trim();

            if (ep.length>0) {
              if (ep.indexOf(",")>-1 || ep.indexOf(";")>-1) {
                this.popDialog(1, "Semicolons and commas not allowed in passwords");
                return;
              }
              if (ep.length < 11) {
                this.popDialog(1,"The password must be at least 11 characters");
                return;
              }
            }
            else {
              this.popDialog(1,"Password is required");
            }

            this.eID.Username= ea.replace(",", "_").replace(";", "_");
            this.eID.Password= ep.replace(",", "_").replace(";", "_");
            this.eID.FirstName= this.eFirstName.replace(",", "_").replace(";", "_");
            this.eID.LastName= this.eLastName.replace(",", "_").replace(";", "_");  

      
          }
          else {
            this.popDialog(1,"Username is required")
          }
        }
      },
      doneSelection(items) {
        if (this.mode==='1') {
          this.assignBundles=items;
        }
        else if (this.mode==='3') {
          this.assignProducts=items;
        }
        else if (this.mode==='4') {
          this.assignTrainingPlans=items;
        }
        this.mode='0';
      },
      editAddInvite(u) {
        this.eID=u;
        this.eEmail=u.EmailAddress;
        this.ePassword=u.Password;
        this.eUser=u.Username;
        this.eFirstName=u.FirstName;
        this.eLastName=u.LastName;
        this.$refs["editModal"].show();
      }, 
      goBack() {
        this.mode='0';
      },
      groupsSelected() {
        this.assignGroups=this.$refs["selectedUserModule"].getData();
        this.mode='0';
      },
      openAssignBundles() {
        this.mode='1';
        this.apiCommand([{
          Operation: "LicensePool",
          Function: "GetBundles",
          Fields: {
            LicensePoolID: this.poolID
          }
        }]).then(r=>{
          var cr=JSON.parse(r.CommandResult);         
          this.$refs["selectedBundleModule"].setData(JSON.parse(cr.returnObjects[0].returnObject));
          
        });
      },
      openAssignProducts() {
        this.mode='3';
        this.apiCommand([{
          Operation: "LicensePool",
          Function: "GetProducts",
          Fields: {
            LicensePoolID: this.poolID,
            LanguageID: sessionStorage.getItem("userLanguageID")
          }
        }]).then(r=>{
          var cr=JSON.parse(r.CommandResult);         
          this.$refs["selectedProductModule"].setData(JSON.parse(cr.returnObjects[0].returnObject));
         
        });
      },
      openAssignGroups() {
        this.mode='2';
        if (this.groupID!==null) {
          this.apiCommand([  {
            Operation: "LicensePool",
            Function: "GetGroupSubGroups",
            Fields: {
              LicensePoolID: this.poolID,
              GroupID: this.groupID
            }
          }]).then(r=>{
            var cr=JSON.parse(r.CommandResult);        
            this.$refs["selectedUserModule"].setData("",[],null,[],JSON.parse(cr.returnObjects[0].returnObject));
          
          });
        }
        else {
          this.apiCommand([{
            Operation: "LicensePool",
            Function: "GetGroups",
            Fields: {
              LicensePoolID: this.poolID
            }
          }]).then(r=>{
            var cr=JSON.parse(r.CommandResult);        
            this.$refs["selectedUserModule"].setData("",[],null,[],JSON.parse(cr.returnObjects[0].returnObject));
          
          });
        }
      },
      openAssignTrainingPlans() {
        this.mode='4';
        this.apiCommand([{
          Operation: "LicensePool",
          Function: "GetCurricula",
          Fields: {
            LicensePoolID: this.poolID
          }
        }]).then(r=>{
          var cr=JSON.parse(r.CommandResult);          
          this.$refs["selectedTPModule"].setData(JSON.parse(cr.returnObjects[0].returnObject));
          
        });
      },
      removeAddInvite(n) {
        var rid=-1;
        for(var x=0; x<this.usersToAdd.length; x++) {
          if (this.usersToAdd[x].Num===n) {
            rid=x;
          }
        }
        if (rid>-1) {
          this.usersToAdd.splice(rid,1);
        }
      },
      removeBundle(nid) {
        var rid=-1;
        for(var x=0; x<this.assignBundles.length; x++) {
          if (this.assignBundles[x].BundleID===nid) {
            rid=x;
          }
        }
        if (rid>-1) {
          this.assignBundles.splice(rid,1);
        }
      },
      removeProduct(nid) {
        var rid=-1;
        for(var x=0; x<this.assignProducts.length; x++) {
          if (this.assignProducts[x].LicensePoolProductID===nid) {
            rid=x;
          }
        }
        if (rid>-1) {
          this.assignProducts.splice(rid,1);
        }
      },
      removeTP(nid) {
        var rid=-1;
        for(var x=0; x<this.assignTrainingPlans.length; x++) {
          if (this.assignTrainingPlans[x].CurriculumID===nid) {
            rid=x;
          }
        }
        if (rid>-1) {
          this.assignTrainingPlans.splice(rid,1);
        }
      },
      removeGroup(nid) {
        var rid=-1;
        for(var x=0; x<this.assignGroups.length; x++) {
          if (this.assignGroups[x].value===nid) {
            rid=x;
          }
        }
        if (rid>-1) {
          this.assignGroups.splice(rid,1);
        }
      },
      runAssignments(users,groupCommands,bundleCommands,productCommands,curriculaCommands) {

        if (groupCommands.length > 0) {
          this.apiCommand(groupCommands).then(r=>{
            var cr=JSON.parse(r.CommandResult);
            for(var x=0; x<groupCommands.length; x++) {
              users.filter(p=>p.id===groupCommands[x].Fields.ClientID)[0].groupitems[x].result=cr.returnObjects[x].returnObject;
            }
          });
        }

        if (bundleCommands.length > 0) {
          this.apiCommand(bundleCommands).then(r=>{
            var cr=JSON.parse(r.CommandResult);
            for(var x=0; x<bundleCommands.length; x++) {
              users.filter(p=>p.id===bundleCommands[x].Fields.ClientID)[0].bundleitems[x].result=cr.returnObjects[x].returnObject;
            }
          });
        }

       if (productCommands.length > 0) {
          this.apiCommand(productCommands).then(r=>{

            var cr=JSON.parse(r.CommandResult);
            for(var x=0; x<productCommands.length; x++) {
              users.filter(p=>p.id===productCommands[x].Fields.ClientID)[0].productitems[x].result=cr.returnObjects[x].returnObject;
            }


            if (curriculaCommands.length > 0) {
              this.apiCommand(curriculaCommands).then(r2=>{
                var cr2=JSON.parse(r2.CommandResult);
                for(var y=0; y<curriculaCommands.length; y++) {
                  users.filter(p=>p.id===curriculaCommands[y].Fields.ClientID)[0].tpitems[y].result=cr2.returnObjects[y].returnObject;
                }
              })
            }

          });
        }
       
      }
    }
  }
</script>
